export default "__VITE_ASSET__DMEkVd9W__"